module.exports = __webpack_public_path__ + "media/media/service/remoteUpdate-3b2ae8983ff50d77ee4438db3698a15d.png";